import styled from "styled-components";

export const AnimalBgContainer = styled.div<{ $bgInvert?: boolean }>`
  display: inline-flex;
  flex-shrink: 0;

  .v-animal-avatar {
    border: var(--border-w) solid var(--ink);
    box-shadow: 0 2px 0 var(--ink);
  }

  img {
    filter: invert(${({ $bgInvert }) => ($bgInvert ? 1 : 0)});
  }
`;
